import axiosClient from './axiosClient'

const authApi = {
  login: (data) => {
    const url = '/login'
    return axiosClient.post(url, data)
  },
  register: (data) => {
    const url = '/create-user'
    return axiosClient.post(url, data)
  },
  searchUser: (email) => {
    const url = `search-user?id=${email}`
    return axiosClient.get(url)
  },
  login3rdParty: (data) => {
    const url = 'login-3rd-party'
    return axiosClient.post(url, data)
  },
  resetPassword: (data) => {
    const url = '/reset-password'
    return axiosClient.patch(url, data)
  },
  getTokenToPay: (id, ref) => {
    const url = `get-token-to-pay?id=${id}&ref=${ref}`
    return axiosClient.get(url)
  },
  createUserPotential: (data) => {
    const url = '/no-auth-create-user-potential'
    return axiosClient.post(url, data)
  }
}

export default authApi
